<div class="how-work">
  <div class="typography typography-huge how-work-title how-work-title_margin-bottom" data-testid="how-work-title">Как это работает?</div>
  <div class="how-work-item how-work-item_padding-left">
    <div class="how-work-content-one">
      <div class="how-work-number typography typography-h2">1</div>
      <div class="typography typography-bold typography-h2 mb-8 how-work-item-title">Закажите</div>
      <div class="typography typography-h4 how-work-text">
        Оформите заказ в мобильном приложении <br> Helix Express. Оплатите заказ онлайн, после оплаты вы получите
        персональный QR-код. Выберите в приложении пункт, где установлен ближайший к вам Лабомат. Если вы сдаете
        анализ крови – выберите пункт, в котором также находится процедурный кабинет.
      </div>
    </div>
    <div>
      <img [src]="images.howWorkOne" alt="">
    </div>
  </div>

  <div class="how-work-item">
    <div class="how-work-img-two">
      <img [src]="images.howWorkTwo" alt="">
    </div>
    <div class="how-work-content-two">
      <div class="how-work-number typography typography-h2">2</div>
      <div class="typography typography-bold typography-h2 mb-8 how-work-item-title">Заберите</div>
      <div class="typography typography-h4 how-work-text">
        Отсканируйте QR-код с помощью сканера Лабомата и получите набор для самостоятельного сбора биоматериала или
        талон на взятие биоматериала в процедурном кабинете.
      </div>
    </div>
  </div>

  <div class="how-work-item how-work-item_padding-left">
    <div class="how-work-content-one">
      <div class="how-work-number typography typography-h2">3</div>
      <div class="typography typography-bold typography-h2 mb-8 how-work-item-title">Сдайте</div>
      <div class="typography typography-h4 how-work-text">
        В комфортной обстановке дома соберите биоматериал в контейнер согласно инструкции в наборе и положите в
        пакет со штрихкодом. Если вы сдаете кровь – воспользуйтесь процедурным кабинетом. Отсканируйте штрихкод на
        пакете с помощью сканера Лабомата и опустите пакет в открывшийся отсек для приема контейнеров.
      </div>
    </div>
    <div>
      <img [src]="images.howWorkThree" alt="">
    </div>
  </div>

  <div class="how-work-item">
    <div class="how-work-img-two">
      <img [src]="images.howWorkFour" alt="">
    </div>
    <div class="how-work-content-two">
      <div class="how-work-number typography typography-h2">4</div>
      <div class="typography typography-bold typography-h2 mb-8 how-work-item-title">Получите</div>
      <div class="typography typography-h4 mb-40 how-work-text">
        Получите результаты анализов в мобильном приложении Helix Express.
      </div>
      <app-mobile-apps-links
        [googlePlayLink]="HelixExpressMobileApp.autodetectStoreLinkExpress"
        [appleStoreLink]="HelixExpressMobileApp.autodetectStoreLinkExpress"
        [appGalleryLink]="''"
      >
      </app-mobile-apps-links>
    </div>
  </div>
</div>
